import { ActionTableSortParamsType } from '../types/table/ActionTableSortParamsType';

export const handleSorting = (
  columnName: string,
  sortParams: ActionTableSortParamsType,
  filteredList: any[],
  setSortParams: (sortParams: ActionTableSortParamsType) => void,
  setFilteredList: (list: any[]) => void
) => {
  let isReverse = false;
  if (columnName === sortParams.column) {
    isReverse = !sortParams.isAsc;
  }
  setSortParams({ ...sortParams, column: columnName, isAsc: isReverse });
  const sortedList = getSortedList(filteredList, columnName, isReverse);

  setFilteredList(sortedList);
};

const getSortedList = (list: unknown[], column: string, isReverse: boolean) => {
  const sortedList = [...list];
  if (column) {
    sortedList.sort((a, b) => {
      const aValue = getValue(a, column);
      const bValue = getValue(b, column);
      return compare(aValue, bValue);
    });
  }
  if (isReverse) {
    sortedList.reverse();
  }
  return sortedList;
};

const getValue = (obj: any, path: string) => {
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
};

function compare(a: string | undefined, b: string | undefined): number {
  if (a === undefined && b === undefined) return 0;
  if (a === undefined) return -1;
  if (b === undefined) return 1;

  // Compare by string length first
  if (a.length > b.length) return 1;
  if (a.length < b.length) return -1;

  // If lengths are equal, compare lexicographically
  return a < b ? -1 : a > b ? 1 : 0;
}
